// stores/chat.js
import { defineStore } from 'pinia';

export const useChatStore = defineStore('chat', {
  state: () => ({
    isOpen: false,
    messages: [],
    hasNewMessages: false,
  }),

  actions: {
    toggleChat() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.hasNewMessages = false;
      }
    },

    closeChat() {
      this.isOpen = false;
    },

    addMessage(message) {
      this.messages.push(message);
      if (!this.isOpen) {
        this.hasNewMessages = true;
      }
      // localStorage에 메시지 저장
      localStorage.setItem('chatMessages', JSON.stringify(this.messages));
    },

    // 초기 메시지 로드
    initializeMessages() {
      const savedMessages = localStorage.getItem('chatMessages');
      if (savedMessages) {
        this.messages = JSON.parse(savedMessages);
      }
    },

    updateMessage(id, content) {
      const message = this.messages.find((msg) => msg.id === id);
      if (message) {
        message.content = content;
        // localStorage 업데이트
        localStorage.setItem('chatMessages', JSON.stringify(this.messages));
      }
    },

    clearMessages() {
      this.messages = [];
      localStorage.removeItem('chatMessages');
    },
  },
});
